export const convertDateToInputFormat = (dateString) => {
  if (!dateString) return "";

  try {
    const parts = dateString.split("/");
    if (parts.length === 3) {
      const day = parts[0].trim();
      const month = parts[1].trim();
      const year = parts[2].trim();

      return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
        2,
        "0"
      )}`;
    }

    if (dateString.includes("-")) {
      return dateString;
    }

    return dateString;
  } catch (e) {
    return dateString;
  }
};

export const convertDateFromInputFormat = (dateString) => {
  if (!dateString) return "";

  try {
    const parts = dateString.split("-");
    if (parts.length === 3) {
      const year = parts[0];
      const month = parts[1];
      const day = parts[2];
      return `${day}/${month}/${year}`;
    }
    return dateString;
  } catch (e) {
    return dateString;
  }
};
